export default "__VITE_ASSET__EpRUlAHz__"